import { cn, Typography } from "@kyan/ui";
import React from "react";

import { InstrumentSummary } from "#/components/InstrumentSummary/InstrumentSummary";

import { useInstrumentsController } from "./Instruments.controller";

export const Instruments = () => {
  const {
    perpLimitPrice,
    optionLimitPrice,
    perpInstrumentData,
    limitNetPriceVariant,
    optionInstrumentsData,
  } = useInstrumentsController();

  return (
    <div className="flex flex-col gap-4">
      <div className="bg-buttonBg dark:bg-buttonFill max-h-41 overflow-y-auto rounded-md">
        {optionInstrumentsData.map(
          ({ instrument, price, isBuySide, size }, index) => {
            return (
              <React.Fragment key={instrument}>
                <InstrumentSummary
                  size={size}
                  key={instrument}
                  bestPrice={price}
                  isBuy={isBuySide}
                  instrumentName={instrument}
                />
                {optionInstrumentsData.length - 1 > index && (
                  <hr className="border-textSecondary/10 h-px w-full" />
                )}
              </React.Fragment>
            );
          },
        )}
      </div>

      <div className="flex justify-between text-xs">
        <Typography>Limit net price</Typography>
        <div className="flex gap-1">
          <Typography
            bold
            grotesk
            className={cn("capitalize", {
              "text-error": limitNetPriceVariant === "debit",
              "text-success": limitNetPriceVariant === "credit",
            })}
          >
            {limitNetPriceVariant}
          </Typography>
          <Typography>{optionLimitPrice}</Typography>
        </div>
      </div>

      {perpInstrumentData && (
        <>
          <InstrumentSummary
            size={perpInstrumentData.size}
            isBuy={perpInstrumentData.isBuySide}
            instrumentName={perpInstrumentData.instrument}
          />

          <div className="flex justify-between text-xs">
            <Typography size={12}>Limit price</Typography>
            <Typography>{perpLimitPrice}</Typography>
          </div>
        </>
      )}

      <hr className="border-divider h-px w-full" />
    </div>
  );
};
